import React from "react";
import { useLenis } from "../hooks/useLenis";
import { useHashScroll } from "../hooks/useHashScroll";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { ApplyModal } from "../components/ApplyModal";

export function PageShell({ children }) {
  useLenis();
  useHashScroll();

  return (
    <div className="min-h-screen bg-[#f5f7fa]">
      <Header />
      <main>{children}</main>
      <Footer />
      <ApplyModal />
    </div>
  );
}
